export default "__VITE_ASSET__G846uXjK__"